import {AssetKind} from './asset-kind.enum';

export abstract class AbstractAsset {
  name: string;
  kind: AssetKind;
  expetedValue;
  usedValue = 0;

  protected constructor(kind: AssetKind) {
    this.kind = kind;
  }
}
